export const syncMessage = (isRecording = false) => {
  return {
    type: 'recording:sync',
    data: {
      isRecording
    }
  }
}
